import type { JobMeta } from "@shared/protocol";

/** Must match backend/ws/handlers/jobs.ts's BINARY_RETENTION_DAYS, which
 *  itself must match r2Infra.ts's ensureR2Lifecycle expireAfterDays for
 *  the pure-jobs bucket (private/auth's aptInfraConfigs.ts) — the actual
 *  30-day auto-delete lives in R2, this is just the UI's own copy of that
 *  number so it can show "Expired" instead of a dead download link. */
export const BINARY_RETENTION_DAYS = 30;
const BINARY_RETENTION_MS = BINARY_RETENTION_DAYS * 24 * 60 * 60 * 1000;

export function isBinaryExpired(job: Pick<JobMeta, "finished_at">): boolean {
  return (
    job.finished_at !== null &&
    Date.now() - job.finished_at > BINARY_RETENTION_MS
  );
}
